import { Component, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SpinnerService } from "./core/services/spinner.service";
import { PwaService } from "./core/services/pwa.service";
import { ModalBienvenidaComponent } from "./pages/auth/components/modal-bienvenida/modal-bienvenida.component";
import { AuthService } from "./core/services/auth.service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, MatProgressSpinnerModule, ModalBienvenidaComponent],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  private readonly spinnerSvc = inject(SpinnerService);
  spinnerLoading = this.spinnerSvc.spinnerLoading;
  spinnerTitulo = this.spinnerSvc.spinnerTitulo;

  constructor(
    public authService: AuthService,
    private pwaService: PwaService,
  ) {}

  ngOnInit(): void {
    this.pwaService.setPwa();
  }
}